import { useContext, useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import Axios from 'axios'

import styles from './styles.module.css'
import ResetImage from '../../assets/reset.png'
import Logo from '../../assets/Logo.png'
import { contextSnack } from '../../context';
import { resetSchema } from './validator';

export default function Reset() {
  const { showSnackbar } = useContext(contextSnack)
  const navigate = useNavigate()
  const { search } = useLocation()
  const token = new URLSearchParams(search).get('t')
  
  const [password, setPassword] = useState("")
  const [passwordError, setPasswordError] = useState("")

  const [confirmPassword, setConfirmPassword] = useState("")
  const [confirmPasswordError, setConfirmPasswordError] = useState("")

  const [showPassword, setShowPassword] = useState(false)
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false)

  const [loading, setLoading] = useState(false)

  const casesErrors = {
    "password": setPasswordError,
    "confirmPassword": setConfirmPasswordError
  }

  useEffect(() => {
    (() => {
      document.title = "Ayude - Redefinir senha"
    })()
  }, [])
  

  const execute = async () => {
    setLoading(true)
    await resetSchema.validate({
      password,
      confirmPassword
    }, {
      abortEarly: false,
    }).then(async () => {
      await Axios.patch(process.env.REACT_APP_AUTH_API + '/redefine-password', {
        new_password: password,
        token
      }).then((res) => {
        console.log(res)
        showSnackbar({
          message: "Senha redefinida com sucesso!",
          severity: "success"
        })
        return navigate("/")
      }).catch((err) => {
        showSnackbar({
          message: err.response.data.error,
          severity: "error"
        })
      }).finally(() => {
        setLoading(false)
      })
    }).catch((err) => {
      for (let _e of err.inner) {
        casesErrors[_e.path as "password" | "confirmPassword"](_e.message)
      }
    }).finally(() => setLoading(false))
  }

  return (
    <div className="container">
      <div className="image">
        <img src={ResetImage} alt="ResetImage" />
      </div>
      <div className="content">
        <div className="box">
          <img src={Logo} alt="Logo Ayude" />
          <div className="containerText">
            <p className="wellcome">Redefinir senha</p>
          </div>
          <div className="form">
            <TextField
              label={password ? "Nova senha" : ""}
              placeholder="Nova senha"
              sx={{
                '& ::placeholder': {
                  fontSize: '1.5rem',
                  fontFamily: "Poppins"
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
                style: {
                  fontSize: '1.5rem',
                  fontFamily: "Poppins"
                },
              }}
              fullWidth
              value={password}
              onChange={(e) => {
                if (passwordError) {
                  setPasswordError('')
                }
                setPassword(e.target.value)
              }}
              error={!!passwordError}
              helperText={passwordError}
              FormHelperTextProps={{
                style: {
                  fontSize: '1.2rem'
                }
              }}
              type={showPassword ? "text" : "password"}
            />
            <TextField
              label={confirmPassword ? "Confirmar senha" : ""}
              placeholder="Confirmar senha"
              sx={{
                '& ::placeholder': {
                  fontSize: '1.5rem',
                  fontFamily: "Poppins"
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPasswordConfirmation(!showPasswordConfirmation)}>
                      {showPasswordConfirmation ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
                style: {
                  fontSize: '1.5rem',
                  fontFamily: "Poppins"
                }
              }}
              fullWidth
              value={confirmPassword}
              onChange={(e) => {
                if (confirmPasswordError) {
                  setConfirmPasswordError('')
                }
                setConfirmPassword(e.target.value)
              }}
              error={!!confirmPasswordError}
              helperText={confirmPasswordError}
              FormHelperTextProps={{
                style: {
                  fontSize: '1.2rem'
                }
              }}
              type={showPasswordConfirmation ? "text" : "password"}

            />
          </div>
          <Button
            className={styles.button}
            variant='contained'
            fullWidth
            color='primary'
            onClick={execute}
            endIcon={loading && <CircularProgress style={{ color: "#fff" }} size={24} />}
          >Alterar senha</Button>
        </div>
      </div>
    </div>
  );
}